import React from 'react'

import logoImage from '../../logo.svg'
import './Logo.css'

const logo = (props: any) => (
    <div className="Logo" style={{ height: props.height }}>
        <img src={logoImage} alt="Jibo" style={{ filter: 'invert(1)', opacity: 0.8 }}/>
    </div>
)

export default logo
